const API_BASE = import.meta.env.VITE_API_URL
  ? `${import.meta.env.VITE_API_URL}/api/admin`
  : "/api/admin";

const DEV_ADMIN_EMAIL = "abdulahcicekli@gmail.com";

function getAccessJwt(): string | null {
  // Cloudflare Access sets CF_Authorization cookie on the admin domain
  const match = document.cookie.match(/CF_Authorization=([^;]+)/);
  return match ? match[1] : null;
}

export async function adminFetch<T = unknown>(
  path: string,
  options?: RequestInit
): Promise<T> {
  const headers = new Headers(options?.headers);
  headers.set("Content-Type", "application/json");

  if (import.meta.env.DEV) {
    headers.set("X-Admin-Email", DEV_ADMIN_EMAIL);
  } else {
    // Send Access JWT as header for cross-domain API calls
    const jwt = getAccessJwt();
    if (jwt) {
      headers.set("Cf-Access-Jwt-Assertion", jwt);
    }
  }

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  });
  const json = await res.json();

  if (!res.ok) {
    const err = new Error(
      (json as { error?: { message?: string } }).error?.message ||
        "Bir hata oluştu"
    );
    (err as Error & { status: number }).status = res.status;
    throw err;
  }

  return json as T;
}

export async function checkAuth(): Promise<boolean> {
  try {
    await adminFetch("/me");
    return true;
  } catch {
    return false;
  }
}
